// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2HSBT","footer":"ModalError_footer__Safka"};